import {ChangeDetectionStrategy, Component, input, ViewEncapsulation} from "@angular/core";
import {CurrencyPipe} from "@angular/common";

@Component({
  standalone: true,
  selector: 'app-donation-state-component',
  imports: [
    CurrencyPipe
  ],
  template: `
    <p class="flex flex-col">
      <span class="text-[#898989]" i18n>Donated</span>
      <span class="text-[#1F2125] text-xl">{{ totalRaised() | currency: currency() : 'symbol' }}</span>
    </p>
    <p class="flex flex-col">
      <span class="text-[#898989]" i18n>Donations</span>
      <span class="text-[#1F2125] text-xl">{{ donations() }}</span>
    </p>
    <p class="flex flex-col">
      <span class="text-[#898989]" i18n>Goal</span>
      <span class="text-[#1F2125] text-xl">{{ goalAmount() | currency: currency() : 'symbol': '1.0-0' }}</span>
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'flex w-full justify-between bg-[#F5F7F8] [&>p]:font-tektur [&>p>span]:font-tektur py-4 px-4 rounded-b-md'
  }
})
export class DonationStateDummyComponent {

  public readonly currency = input<string>('EUR');
  public readonly totalRaised = input<number>(0);
  public readonly goalAmount = input<number>(0);
  public readonly donations = input<number>(0);

}
